var map = {
	"./airbnb.avif": 1278,
	"./bobs.avif": 4304,
	"./decathlon.avif": 60,
	"./mcdonalds.avif": 549,
	"./nintendo.avif": 8021,
	"./razer-gold.avif": 2415,
	"./rihappy.avif": 9929,
	"./roblox.avif": 3382,
	"./spotify.avif": 7526,
	"./uber.avif": 6532,
	"./zattini.avif": 6809,
	"./zedelivery.avif": 3477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7416;